var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-switch=\"mode\" class=\"signature-text controls\"><div class=\"form-group signature-modal-container field\"><label class=\"control-label\"><div id=\"typed-signature-box\" ng-bind=\"field.value\" class=\"signature\"></div><div class=\"typed-sign-wrap\"><div ng-switch-when=\"edit\" class=\"input-group\"><input id=\"typed-signature\" type=\"text\" name=\"{{field.name}}\" ng-required=\"field.required\" ng-model=\"field.value\"><div style=\"text-align:right;\" class=\"sign-switch\"><a ng-click=\"switch_to_draw()\">Prefer to draw your signature? Click here</a></div></div></div></label></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/signatureText/signatureText.jade
// module id = 356
// module chunks = 0